import { useEffect, useRef, useState } from 'react';
import { Button, ButtonSizes, ButtonStyles, Icon, Icons } from '@silverfort/sf-components';
import IpTextField from './IpTextField';
import { IP_PATTERN } from '@silverfort-nodelibs/common/utils/consts';

const IpSelector = ({ selectedIps, onAdd, isOpen, onClose }) => {
    const [ipSearchTerm, setIpSearchTerm] = useState('');
    const [open, setOpen] = useState(false);
    const [isInvalidIp, setIsInvalidIp] = useState(false);
    const [isAlreadyExists, setIsAlreadyExists] = useState(false);
    const menuRef = useRef(null);

    const openMenu = (e) => {
        e.preventDefault();
        if (!open) {
            setOpen(true);
        } else {
            closeMenu(e);
        }
    };

    const closeMenu = (e) => {
        if (open && !menuRef.current?.contains(e?.target)) {
            setOpen(false);
            onClose();
        }
    };

    const handleAddIp = () => {
        if (!IP_PATTERN.test(ipSearchTerm)) {
            setIsInvalidIp(true);
            return;
        }

        if (selectedIps.includes(ipSearchTerm)) {
            setIsAlreadyExists(true);
            return;
        }

        if (ipSearchTerm) {
            onAdd(ipSearchTerm);
            setIpSearchTerm('');
        }
    };

    const onIpChange = (val) => {
        setIpSearchTerm(val);
        setIsInvalidIp(false);
        setIsAlreadyExists(false);
    };

    useEffect(() => {
        document.addEventListener('click', closeMenu);
        return () => document.removeEventListener('click', closeMenu);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    return (
        <div className="relative origin-top-right">
            <Button
                buttonStyle={ButtonStyles.Primary}
                text="Add"
                iconLeft={Icons.Add}
                onClick={openMenu}
                buttonSize={ButtonSizes.Small}
            />

            {open && (
                <div
                    ref={menuRef}
                    className="absolute z-20 mt-2 py-1 rounded-lg bg-white shadow-sf-medium w-[280px] origin-top-left right-0">
                    <div className="flex items-center w-full border-b h-10 px-2">
                        <IpTextField className="w-full" ip={ipSearchTerm} onChange={onIpChange} onAdd={handleAddIp} />
                    </div>
                    {ipSearchTerm && (
                        <div className="p-2 h-fit cursor-pointer" onClick={handleAddIp}>
                            <div className="border rounded px-3 py-2 flex flex-row items-center gap-1 text-sf-blue">
                                <Icon className="text-sf-blue" icon={Icons.Add} size={16} />
                                <span className="text-13">"{ipSearchTerm}"</span>
                            </div>
                            {isInvalidIp && <span className="text-red-500 text-12 mt-2">Invalid IP</span>}
                            {isAlreadyExists && <span className="text-red-500 text-12 mt-2">IP already exists</span>}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default IpSelector;
